(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["thackray-product-editorial"] && !Shopify.designMode) return;
  try {
    function initialiseThackrayEditorial() {
    if (!document.body.classList.contains('thackray-product-editorial')) return;
    const header = document.querySelector('.section-header');
    if (header && !header.dataset.thackrayMeasured) {
      header.dataset.thackrayMeasured = 'true';
      const measure = () => document.body.style.setProperty('--thackray-header-height', `${header.offsetHeight}px`);
      new ResizeObserver(measure).observe(header);
      measure();
      const updateHeader = () => document.body.classList.toggle('thackray-header-scrolled', window.scrollY > header.offsetHeight);
      window.addEventListener('scroll', updateHeader, { passive: true });
      updateHeader();
    }
    document.querySelectorAll('product-info media-gallery').forEach((gallery) => {
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      if (!viewer || viewer.dataset.thackrayReady) return;
      viewer.dataset.thackrayReady = 'true';
      const track = viewer.querySelector('.product__media-list');
      if (track) {
        const refreshPages = () => viewer.resetPages?.();
        requestAnimationFrame(refreshPages);
        window.addEventListener('load', refreshPages, { once: true });
        viewer.querySelectorAll('.slider-buttons button').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault(); event.stopImmediatePropagation();
            refreshPages();
            track.scrollBy({left: (button.name === 'next' ? 1 : -1) * track.clientWidth});
          }, true);
        });
        let startX = 0, startLeft = 0, dragging = false, moved = false;
        track.addEventListener('dragstart', (event) => event.preventDefault());
        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('video, iframe, model-viewer')) return;
          startX = event.clientX; startLeft = track.scrollLeft; dragging = true; moved = false;
        });
        window.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          const distance = event.clientX - startX;
          if (Math.abs(distance) > 6) { moved = true; track.classList.add('is-dragging'); }
          if (moved) track.scrollLeft = startLeft - distance;
        });
        const finishDrag = () => {
          if (!dragging) return;
          dragging = false; track.classList.remove('is-dragging');
          if (moved) track.scrollTo({left: Math.round(track.scrollLeft / track.clientWidth) * track.clientWidth});
        };
        window.addEventListener('pointerup', finishDrag);
        window.addEventListener('pointercancel', finishDrag);
        track.addEventListener('click', (event) => { if (moved) { event.preventDefault(); event.stopImmediatePropagation(); moved = false; } }, true);
      }
      viewer.addEventListener('slideChanged', (event) => {
        const active = event.detail.currentElement;
        if (!active) return;
        gallery.querySelectorAll('.product__media-item').forEach((item) => item.classList.toggle('is-active', item === active));
        window.pauseAllMedia?.();
      });
      viewer.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.target.closest('video, iframe, model-viewer, input')) return;
        const button = viewer.querySelector(`[name="${event.key === 'ArrowLeft' ? 'previous' : 'next'}"]`);
        if (button && !button.disabled) { event.preventDefault(); button.click(); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseThackrayEditorial);
  else initialiseThackrayEditorial();
  document.addEventListener('shopify:section:load', initialiseThackrayEditorial);
  } catch(e) { console.error(e); }
})();

})();
